"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlaceValid = void 0;
const isPlaceValid = (place) => {
    const keysOfInterest = [
        'address1',
        'locality',
        'state',
        'zipCode',
        'gmapsPlaceId',
        'latitude',
        'longitude',
    ];
    return keysOfInterest.every((key) => place[key] !== undefined &&
        place[key] !== null &&
        place[key] !== '');
};
exports.isPlaceValid = isPlaceValid;
//# sourceMappingURL=placeUtils.js.map